import { Outlet } from "react-router-dom";

import { AppSidebar } from "components/AppSidebar";
import { SidebarMobileTriggerBar } from "components/sidebar/SidebarMobileTrigger";
import { SIDEBAR_STYLE } from "components/sidebar/sidebarShell";
import { SidebarProvider, SidebarInset } from "components/ui/sidebar";
import RequireAuth from "routes/higher-order/RequireAuthHOC";
import useGlobalSidebarStore from "stores/useGlobalSidebarStore";

export function ProtectedLayout({ hideNav = false }) {
  const open = useGlobalSidebarStore(state => state.open);
  const setOpen = useGlobalSidebarStore(state => state.setOpen);

  return (
    <RequireAuth>
      <SidebarProvider open={open} onOpenChange={setOpen} style={SIDEBAR_STYLE}>
        {!hideNav && <AppSidebar />}
        {/* The only viewport-sized box. It clips rather than scrolls, so each
            page layout below owns the single vertical scroll container. The
            inset is a <main>, and Semantic UI's unlayered
            `main { display: block }` rule beats Tailwind's layered utilities,
            so `flex` needs the `!` suffix or the page layouts below grow past
            the viewport. */}
        <SidebarInset className="tw:flex-1 tw:flex! tw:flex-col tw:overflow-hidden tw:min-h-0 tw:h-svh">
          {!hideNav && <SidebarMobileTriggerBar label="Main Menu" />}
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </RequireAuth>
  );
}
